/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_No_Valid_TermsInputs */

const en_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No valid terms found in CSV`)
};

const fr_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun terme valide trouvé dans le CSV`)
};

const de_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der CSV-Datei wurden keine gültigen Begriffe gefunden.`)
};

const it_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun termine valido trovato nel CSV`)
};

const ru_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В CSV-файле не найдено допустимых терминов.`)
};

const es_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron términos válidos en CSV`)
};

const zh_cn2_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 文件中未找到有效术语。`)
};

const ja_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV に有効な用語が見つかりません`)
};

const hi_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV में कोई मान्य शब्द नहीं मिले`)
};

const pt_pt2_knp_terms_no_valid_terms = /** @type {(inputs: Knp_Terms_No_Valid_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum termo válido encontrado no arquivo CSV.`)
};

/**
* | output |
* | --- |
* | "No valid terms found in CSV" |
*
* @param {Knp_Terms_No_Valid_TermsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_no_valid_terms = /** @type {((inputs?: Knp_Terms_No_Valid_TermsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_No_Valid_TermsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_no_valid_terms(inputs)
	if (locale === "de") return de_knp_terms_no_valid_terms(inputs)
	if (locale === "it") return it_knp_terms_no_valid_terms(inputs)
	if (locale === "ru") return ru_knp_terms_no_valid_terms(inputs)
	if (locale === "es") return es_knp_terms_no_valid_terms(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_no_valid_terms(inputs)
	if (locale === "ja") return ja_knp_terms_no_valid_terms(inputs)
	if (locale === "hi") return hi_knp_terms_no_valid_terms(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_no_valid_terms(inputs)
	return en_knp_terms_no_valid_terms(inputs)
});